export enum EmploymentTypeEnum {
  UNION = 1,
  NON_UNION,
}
